import React from 'react';
import axios from './../../../constants/axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';

class PurchaseReturnHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoices: []
      };
   }


   componentDidMount() {
      axios.get('purchaseReturns')
         .then((res) => {
            this.setState({
               invoices: res.data
            });
         });
   }


   render() {
      const { invoices } = this.state;
      return (
         <div className="PurchaseReturnHome" >
            <h1>Purchase Return Home</h1>
            <Table>
               <thead>
               <tr>
                  <th>#inv Id</th>
                  <th>Contact Name</th>
                  <th>Amount Billed</th>
                  <th>Amount Receivable</th>
                  <th>Inv Created</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {invoices.map((invoice) => (
                  <tr key={invoice.id} >
                     <td>{invoice.id}</td>
                     <td>{invoice.contact_name}</td>
                     <td>{invoice.amount}</td>
                     <td>{invoice.amount_due}</td>
                     <td>{invoice.created_at}</td>
                     <td>
                        <Link to={`/invoice/invoiceInvoiceDetail/${invoice.id}`} >Details</Link >j
                        <Link to={`/invoice/invoiceReceivePayment/${invoice.id}`} >Receive Payment</Link >
                     </td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

PurchaseReturnHome.propTypes = {};

export default PurchaseReturnHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/PurchaseReturn/PurchaseReturnHome.js
 **/